import callActivityPropertiesProvider from './PropertiesProvider';

export default {
  __init__: [ 'callActivityPropertiesProvider' ],
  callActivityPropertiesProvider: [ 'type', callActivityPropertiesProvider ]
};